<template>
  <div id="app">
    <!--<img src="./assets/logo.png">-->
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: "游ゴシック", YuGothic, "ヒラギノ角ゴ ProN W3", "Hiragino Kaku Gothic ProN", "メイリオ", Meiryo, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
input[type="button"] {
    -webkit-appearance: none;
    border-radius: 0;
    font-family: "游ゴシック", YuGothic, "ヒラギノ角ゴ ProN W3", "Hiragino Kaku Gothic ProN", "メイリオ", Meiryo, sans-serif;
}
.p-partnerlogo__img {
    margin-left: auto;
    margin-right: 0rem;
}
.l-footer__copyright {
    text-align: right;
}
.f_aws {
width: auto;
height: 80px;
margin-right: 1.6rem;
}
.f_isms {
width: auto;
height: 80px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue